<div [ngClass]="oscCodes.includes(gdSession?.oscConfig?.oscCode) ? 'tofel-modal-header' : 'modal-header'" tabindex="0">
    <h3 mat-dialog-title [ngClass]="oscCodes.includes(gdSession?.oscConfig?.oscCode) ? 'tofel-dialog-title' : 'mat-mdc-dialog-title mdc-dialog__title'">
        Alipay+
    </h3>
    <button mat-icon-button class="close-button" aria-label="Close modal" (click)="exit()" role="button" tabindex="0">
        <mat-icon class="close-icon" aria-hidden="true">close</mat-icon>
    </button>
</div>
<mat-dialog-content *transloco="let t">
    <p>
        {{t('alipay.learnmore.ewallet.infotext')}}
    </p>
    <ul class="no-bullets">
        <li>{{t('alipay.learnmore.alipaychina')}}</li>
        <li>{{t('alipay.learnmore.alipayhk')}}</li>
        <li>{{t('alipay.learnmore.kakao')}}</li>
        <li>{{t('alipay.learnmore.kredivo')}}</li>
        <li>{{t('alipay.learnmore.gcash')}}</li>
        <li>{{t('alipay.learnmore.touchngo')}}</li>
        <li>{{t('alipay.learnmore.rabbitline')}}</li>
        <li>{{t('alipay.learnmore.truemoney')}}</li>
        <li>{{t('alipay.learnmore.dana')}}</li>
        <li>{{t('alipay.learnmore.akulaku.ind')}}</li>
        <li>{{t('alipay.learnmore.akulaku.phi')}}</li>
        <li>{{t('alipay.learnmore.naverpay.ind')}}</li>
        <li>{{t('alipay.learnmore.tosspay.ind')}}</li>
    </ul>
    <p>{{t('alipay.learnmore.paysupport.text')}}</p>

    <ul class="payment-logos no-bullets">
        <li class="payment-logo--large" tabindex="0" >
            <img class="alipay" src="../../assets/img/AlipayPlus.png" alt="Alipay+ logo, a platform for local payment methods" />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/alipay.png" alt="Alipay logo representing China" />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/alipayhk.png" alt="Alipay HK logo representing Hong Kong"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/kakoapay.png" alt="KaKao Pay logo representing South Korea"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/gcash.png" alt="Gcash logo representing the Philippines"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/touchngo.png" alt="Touch 'n Go eWallet logo representing Malaysia"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/rabbitlinepay.png" alt="Rabbit LINE Pay logo representing Thailand"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/truemoney.png" alt="Truemoney logo representing Thailand"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/dana.jpg" alt="DANA logo representing Indonesia"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/akulakuPaylater.png" alt="Akulaku Paylater logo representing Indonesia and the Philippines"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/alipay/Kredivo.png" alt="Kredivo"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/alipay/Naverpay3.png" alt="NaverPay"  />
        </li>
        <li class="payment-logo" tabindex="0">
            <img class="alipay-img" src="../../assets/img/alipay/TossPay2.png" alt="TossPay"  />
        </li>
    </ul>
</mat-dialog-content>